<template>
  <div class="virtual-keyboard">
    <!-- Textfeld mit Label -->
    <div class="keyboard-display">
      <label class="keyboard-label">{{ label }}</label>
      <input
        type="text"
        v-model="inputText"
        readonly
        class="keyboard-input"
        placeholder="Eingabe hier"
      />
    </div>

    <!-- Tastatur -->
    <div class="keyboard-keys">
      <div class="keyboard-row" v-for="(row, rowIndex) in keyRows" :key="rowIndex">
        <button
          v-for="key in row"
          :key="key"
          @click="handleKeyClick(key)"
          :class="[
            'keyboard-key',
            {
              'keyboard-enter': key === 'Enter',
              'keyboard-backspace': key === 'Backspace',
              'keyboard-space': key === ' ',
              'keyboard-cancel': key === 'Abbruch'
            }
          ]"
        >
          {{ getKeyLabel(key) }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VirtualKeyboard",
  props: {
    label: {
      type: String,
      default: "Eingabe"
    }
  },
  data() {
    return {
      inputText: "",
      shift: true,
      keyRows: [
        ['q', 'w', 'e', 'r', 't', 'z', 'u', 'i', 'o', 'p'],
        ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'],
        ['Shift', 'y', 'x', 'c', 'v', 'b', 'n', 'm', 'Backspace'],
        [' ', 'Enter', 'Abbruch']
      ]
    };
  },
  methods: {
    handleKeyClick(key) {
      if (key === 'Shift') {
        this.shift = !this.shift;
      } else if (key === 'Backspace') {
        this.inputText = this.inputText.slice(0, -1);
      } else if (key === 'Enter') {
        this.$emit('enter', this.inputText);
        this.inputText = "";
      } else if (key === 'Abbruch') {
        this.$emit('close');
        this.inputText = "";
      } else if (key === ' ') {
        this.inputText += ' ';
      } else {
        this.inputText += this.shift ? key.toUpperCase() : key.toLowerCase();
        if (this.shift) this.shift = false;
      }
      if (key !== 'Shift' && this.shift) {
        this.shift = false;
      }
    },
    getKeyLabel(key) {
      if (key === 'Shift' || key === 'Enter' || key === 'Backspace' || key === 'Abbruch') {
        return key;
      } else if (key === ' ') {
        return 'Space';
      }
      return this.shift ? key.toUpperCase() : key.toLowerCase();
    }
  }
};
</script>

<style scoped>
.virtual-keyboard {
  display: inline-block;
  width: 100%;
  max-width: 800px;
  user-select: none;
  font-family: sans-serif;
}

.keyboard-display {
  margin-bottom: 20px;
  text-align: center;
}

.keyboard-label {
  display: block;
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 10px;
}

.keyboard-input {
  font-size: 32px;
  padding: 15px;
  width: 100%;
  text-align: center;
  border-radius: 10px;
  border: 2px solid #333;
  box-sizing: border-box;
}

.keyboard-keys {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.keyboard-row {
  display: flex;
  justify-content: center;
  margin: 5px 0;
  width: 100%;
}

.keyboard-key {
  font-size: 24px;
  padding: 20px 0;
  margin: 3px;
  flex: 1;
  min-width: 60px;
  border-radius: 10px;
  border: 1px solid #555;
  cursor: pointer;
  background-color: #f0f0f0;
  transition: background 0.2s;
  text-align: center;
}

.keyboard-key:hover {
  background-color: #ddd;
}

.keyboard-enter {
  background-color: #4CAF50;
  color: white;
  flex: 2;
  min-width: 120px;
}

.keyboard-backspace {
  background-color: #f44336;
  color: white;
}

.keyboard-space {
  flex: 5;
  min-width: 200px;
}

.keyboard-cancel {
  background-color: #999;
  color: white;
  flex: 2;
  min-width: 120px;
}
</style>
